import { TeamsAndUsersList } from '../../../../components/settings/types/users-and-teams';
import { getFilterOptions } from './get-filtered-options';
import { getOptions } from './get-options';

export const getSelectedOptionKey = (
  teamsAndUsersList: TeamsAndUsersList[],
  selectedUserIds: number[],
  search: string,
): string[] => {
  const filteredOptions = getFilterOptions(
    getOptions(teamsAndUsersList),
    search,
  );

  // Initialize an array to store selected team and user keys
  const selectedKeys = [];

  // Loop through the "teams" array
  filteredOptions.forEach((team) => {
    // Check if the team is of type "team"
    if (team.type === 'team') {
      // Check if all users in the team are selected
      const allUsersSelected = team.users.every((user) =>
        selectedUserIds.includes(user.id),
      );

      // If all users are selected, add the team key to the selectedKeys array
      if (allUsersSelected) {
        selectedKeys.push(team.key);
      }
    }
    // If the team is of type "user" and the user is selected, add their key to selectedKeys
    else if (team.type === 'user' && selectedUserIds.includes(team.id)) {
      selectedKeys.push(team.key);
    }
  });
  return selectedKeys;
};
